import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const notificationState = (state: RootState) => state.notification;

export const getNotifications = createSelector(
  notificationState,
  ({ notifications }) => notifications
);

export const getNotificationUnreadCount = createSelector(
  notificationState,
  ({ unreadTotal }) => unreadTotal
);

export const getNotificationUnreadUnfilteredCount = createSelector(
  notificationState,
  ({ unreadUnfilteredTotal }) => unreadUnfilteredTotal
);

export const getNotificationTotalCount = createSelector(notificationState, ({ total }) => total);

export const isOnlyMentions = createSelector(notificationState, ({ onlyMentions }) => onlyMentions);

export const isNotificationLoading = createSelector(notificationState, ({ loading }) => loading);

export const isNotificationDeleting = createSelector(notificationState, ({ deleting }) => deleting);

export const isCadenceModalShowing = createSelector(
  notificationState,
  ({ cadenceModal }) => cadenceModal.visible
);

export const getCadenceModalEntities = createSelector(
  notificationState,
  ({ cadenceModal }) => cadenceModal.entities
);

export const getCadenceModalNotification = createSelector(
  notificationState,
  ({ cadenceModal }) => cadenceModal.notification
);

export const isNotificationCadenceDataLoading = createSelector(
  notificationState,
  ({ cadenceModal }) => cadenceModal.loading
);

export const getBouncedEmail = createSelector(
  notificationState,
  ({ bouncedEmailModal }) => bouncedEmailModal.notification?.entity?.[0]?.email
);

export const getBouncedEmailEntity = createSelector(
  notificationState,
  ({ bouncedEmailModal }) => bouncedEmailModal.entity
);

export const isBouncedEmailModalVisible = createSelector(
  notificationState,
  ({ bouncedEmailModal }) => bouncedEmailModal.visible
);

export const isBouncedEmailEntityEmailUpdating = createSelector(
  notificationState,
  ({ bouncedEmailModal }) => bouncedEmailModal.entityEmailUpdating
);

export const isNotificationsVisible = createSelector(notificationState, ({ visible }) => visible);
